import React from 'react';
import './ui.css';

/** "Popular Apps ................ View all" section header. */
export default function SectionHeader({ title, actionLabel, onAction }) {
  return (
    <div className="hive-section-header">
      <h2 className="hive-section-title">{title}</h2>
      {actionLabel && (
        <button type="button" className="hive-section-action hive-tap hive-focusable" onClick={onAction}>
          {actionLabel}
        </button>
      )}
    </div>
  );
}
